import { resolveSelectedCurrencyFromStatements } from './statementSelection';

const defaultGetFamily = (statement) => {
    return statement?.Transaction?.Family || statement?.TransactionFamily || statement?.Family;
};

export const buildInvoiceStatementObjects = (
    statements,
    { getFamily = defaultGetFamily, includeStatement = () => true } = {}
) => {
    if (!statements || statements.length === 0) {
        return [];
    }

    return statements
        .filter((statement) => includeStatement(statement, getFamily(statement)))
        .map((statement) => ({
            ID: statement.ID,
            Family: getFamily(statement),
            isCommission: statement.isCommission,
            isAdvance: statement.isClientAdvance,
            DepartmentCreated: statement.DepartmentCreated,
        }));
};

export const countAgencyFeeStatements = (
    statements,
    { getFamily = defaultGetFamily, matchStatement = (statement) => statement.isCommission || statement.isClientAdvance } = {}
) => {
    if (!statements || statements.length === 0) {
        return 0;
    }

    return statements.reduce((count, statement) => {
        return matchStatement(statement, getFamily(statement)) ? count + 1 : count;
    }, 0);
};

export const buildInvoiceDraftData = ({
    statements,
    contactID,
    contactName,
    contactTypeLabel,
    billingInfo,
    defaultCurrency,
    projectName,
    agencyFeeCount,
    getFamily = defaultGetFamily,
    includeStatement,
}) => {
    const data = {
        Type: contactTypeLabel,
        ContactID: contactID,
        ContactName: contactName,
        BillingInfoID: billingInfo.ID,
        BillingInfoDefaultPaymentTermCode: billingInfo.PaymentTermCode,
        SelectedStatementObjects: buildInvoiceStatementObjects(statements, { getFamily, includeStatement }),
        Currency: resolveSelectedCurrencyFromStatements(statements, defaultCurrency),
    };

    if (projectName) {
        data.ProjectName = projectName;
    }

    if (agencyFeeCount !== undefined) {
        data.AgencyFeeCount = agencyFeeCount;
    }

    return data;
};
